import * as React from "react";

import {Body} from "@khanacademy/wonder-blocks-typography";

import type {ActivitySessionsV2Query_user_activityLogV2_activitySessions_sessions as ActivitySessionsReportRow} from "./__graphql-types__/ActivitySessionsV2Query.ts";
import {DefaultNotApplicable} from "./change-indicator.tsx";
import isBasicActivitySession from "./is-basic-activity-session.ts";

interface Props {
    row: ActivitySessionsReportRow;
}

const ActivityScoreCell: React.FC<Props> = ({row}) => {
    if (isBasicActivitySession(row)) {
        return <DefaultNotApplicable />;
    }

    return row.correctCount != null &&
        row.problemCount != null &&
        !row.task?.isRestarted ? (
        <Body>{`${row.correctCount}/${row.problemCount}`}</Body>
    ) : (
        <DefaultNotApplicable />
    );
};

export default ActivityScoreCell;
